import { useEffect, useState } from "react";
import { api, COMPANY } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Phone } from "lucide-react";
import { onCallClick } from "@/lib/dialer";

const TONS = ["3 Ton", "4 Ton", "5 Ton"];
const ORDER = ["Midea", "Fuji", "Goodman", "Carrier", "Lennox"];

export default function Pricing() {
  const { t } = useLang();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/pricing").then(r => setRows(r.data)).catch(()=>{}); }, []);

  const byBrand = {};
  rows.forEach(r => { (byBrand[r.brand] = byBrand[r.brand] || {})[r.tonnage] = r.price; });
  const brands = ORDER.filter(b => byBrand[b]);

  return (
    <section id="pricing" className="py-12 md:py-20 bg-ink-800/30" data-testid="pricing">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.22em] text-ice-400">{t("pricing.title")}</div>
        <h2 className="mt-3 font-display text-3xl md:text-4xl font-black max-w-3xl">{t("pricing.sub")}</h2>

        <div className="mt-8 overflow-x-auto no-scrollbar -mx-5 md:mx-0">
          <div className="min-w-[640px] md:min-w-0 px-5 md:px-0">
            <div className="grid grid-cols-4 gap-3 text-xs uppercase tracking-[0.18em] text-silver-400 px-4 pb-3">
              <div>Brand</div>{TONS.map(t => <div key={t}>{t}</div>)}
            </div>
            <div className="rounded-2xl overflow-hidden ring-1 ring-white/10 bg-ink-800">
              {brands.map((brand, idx) => (
                <div key={brand} className={`grid grid-cols-4 gap-3 items-center px-4 py-4 ${idx%2 ? "bg-ink-800" : "bg-ink-800/60"}`} data-testid={`price-row-${brand}`}>
                  <div className="font-display font-bold text-base">{brand}</div>
                  {TONS.map(tn => (
                    <div key={tn} className="font-display text-lg md:text-xl font-semibold tabular-nums">
                      {byBrand[brand]?.[tn] ? `$${byBrand[brand][tn].toLocaleString()}` : <span className="text-silver-500">—</span>}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        <p className="mt-5 text-xs text-silver-400 max-w-3xl">
          Pricing may vary depending on installation requirements, equipment availability, and project conditions. Contact AIR-COLD HVAC for a free estimate.
        </p>

        <div className="mt-8 grid md:grid-cols-2 gap-4">
          <div className="rounded-2xl bg-ink-800 ring-1 ring-white/10 p-5" data-testid="pricing-popular-note">
            <h3 className="font-display font-bold text-base">Popular Options Above</h3>
            <p className="mt-1.5 text-sm text-silver-300">These are some of our most popular equipment options. We also service, repair, and install many other HVAC brands.</p>
          </div>
          <div className="rounded-2xl bg-gradient-to-br from-ice-400/15 to-transparent ring-1 ring-ice-400/30 p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between" data-testid="pricing-other-brand">
            <div>
              <h3 className="font-display font-bold text-base">Don&apos;t see your brand listed?</h3>
              <p className="mt-1.5 text-sm text-silver-300">Contact AIR-COLD HVAC. Our technicians work on nearly every major HVAC manufacturer.</p>
            </div>
            <a href={`tel:${COMPANY.phoneTel}`} onClick={onCallClick} className="btn-primary rounded-full px-4 py-2.5 text-sm flex items-center gap-2 shrink-0" data-testid="pricing-other-call"><Phone className="size-4"/> {COMPANY.phone}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
